import Shepherd from 'shepherd.js'
import type { TourOptions } from './types'

import './styles.less'

// 要与 styles.less 定义同步
export const customCssClasses = {
  buttonPrimary: 'shepherd-button__primary',
  firstStep: 'first-step',
  secondStepAddButtonPrimary: 'second-step-add-button-primary'
}

function useShepherd(options?: TourOptions) {
  return new Shepherd.Tour(options)
}

export default useShepherd
